import { apiService } from '@shared/services/apiServices';
import type {
  ListContactRequestsParams,
  ListContactRequestsResponse,
} from '../types/contactRequestTypes';
import contactRequestEndpoints from './contactRequestEndpoints';

export const listContactRequestsApiService = {
  listContactRequests: async (
    params?: ListContactRequestsParams
  ): Promise<ListContactRequestsResponse> => {
    const queryParams = new URLSearchParams();

    if (params?.page) {
      queryParams.append('page', params.page.toString());
    }
    if (params?.limit) {
      queryParams.append('limit', params.limit.toString());
    }
    if (params?.search) {
      queryParams.append('search', params.search);
    }
    if (params?.status) {
      queryParams.append('status', params.status);
    }
    if (params?.startDate) {
      queryParams.append('startDate', params.startDate);
    }
    if (params?.endDate) {
      queryParams.append('endDate', params.endDate);
    }

    const qs = queryParams.toString();
    const endpoint = `${contactRequestEndpoints.LIST_CONTACT_REQUESTS}${qs ? `?${qs}` : ''}`;
    const response = await apiService.getAPI(endpoint);

    if (response.error) {
      return {
        data: [],
        pagination: {
          page: params?.page ?? 1,
          limit: params?.limit ?? 10,
          totalCount: 0,
          totalPages: 0,
          hasNextPage: false,
          hasPreviousPage: false,
        },
      };
    }

    return response.data as ListContactRequestsResponse;
  },
};
